import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterSocial"] */ "/vercel/path0/apps/web/src/components/layout/FooterSocial.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/layout/HeaderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderHome"] */ "/vercel/path0/apps/web/src/components/layout/HeaderHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeTabs"] */ "/vercel/path0/apps/web/src/components/layout/HomeTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainSidebar"] */ "/vercel/path0/apps/web/src/components/layout/MainSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/layout/MainWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewModeSections"] */ "/vercel/path0/apps/web/src/components/layout/PreviewModeSections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@opentelemetry+api@1.9.0_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@opentelemetry+api@1.9.0_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/packages/ui/src/components/tooltip.tsx");
